module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-impressum-info-2209c88267879a2978a94435d1f49792.svg";